module.exports = __webpack_public_path__ + "img/majoituspalvelu_original.0a125f54.jpg";